module.exports = __webpack_public_path__ + "img/2_5.2dae3bc0.png";